<form *ngIf="showPostfachAdresse" [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="postfachadressePostfach{{index}}">{{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.POSTFACH' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="postfachadressePostfach{{objectId}}" formControlName="postfach" id="postfachadressePostfach{{index}}"
             type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

  <div class="form-row">
    <label class="d-sm-none col-form-label"
           for="postfachadressePostleitzahl{{index}}">{{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.PLZ' | translate }}</label>
    <label class="d-none d-sm-inline col-sm-4 col-form-label">
      {{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.PLZ_ORT' | translate }}
    </label>
    <div class="col-sm-2">
      <input class="form-control" datevMessagePath="postfachadressePostleitzahl{{objectId}}" formControlName="postleitzahl" id="postfachadressePostleitzahl{{index}}"
             type="text" utilsCheckValidity utilsControlState
             utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none col-form-label"
           for="postfachadresseOrt{{index}}">{{ 'COMMON_UI.ADRESSEN.POSTFACHADRESSE.ORT' | translate }}</label>
    <div class="col-sm-6">
      <input class="form-control" datevMessagePath="postfachadresseOrt{{objectId}}" formControlName="ort" id="postfachadresseOrt{{index}}" type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired
             utilsValidationMessage/>
    </div>
  </div>

</form>
